<template>
  <button
    class="flex items-center gap-2 whitespace-nowrap rounded bg-zuno-turquoise px-4 py-2 text-sm text-white shadow-sm outline-none"
    type="button"
    @click="navigateToLogsPage"
  >
    <span>View All Logs</span>
    <ViewLog />
  </button>
</template>

<script>
export default {
  name: 'ViewLogsButton',

  data() {
    return {
      tierCanViewLogs: false,
    }
  },

  async mounted() {
    this.tierCanViewLogs = await this.$apis.tiers.checkLimit('audit_log')
  },

  methods: {
    navigateToLogsPage() {
      navigateTo({
        path: this.tierCanViewLogs
          ? '/dashboard/emission-audit/log'
          : '/errors/ErrorPermission',
      })
    },
  },
}
</script>
